<script>
import { BModal } from 'bootstrap-vue';
import { Confirm } from '../services/Confirm';

const Alert = require('../services/alert.js');
const Storage = require('../services/storage.js');
const Selection = require('../services/selection.js');

export default {
  components: {
    BModal,
  },

  created () {
    this.getForm();
    this.getCustomFields();
  },

  mounted () {
    this.$nextTick(() => {
      this.modalElement = this.$refs['question-modal'];
    });
  },

  props: ['form'],

  data () {
    return {
      loading: true,
      questions: [],
      options: [],
      status: {
        saving: false,
        questionInEditionIndex: null,
      },
      modalElement: null,
      modal: {
        title: null,
        question: null,
        name: null,
        type: 'text',
        cols: null,
        rules: 'required',
        mask: '',
        placeholder: '',
        step: null,
      },
      questionTypes: [
        { text: null, value: null },
        { text: 'Campo de texto', value: 'text' },
        { text: 'Campo de área', value: 'textarea' },
        { text: 'Selecionar de uma lista', value: 'select' },
        { text: 'Selecionar opção', value: 'radio' },
        { text: 'Checkbox', value: 'checkbox' },
        { text: 'Data', value: 'date' },
        { text: 'Hora', value: 'time' },
        { text: 'E-mail', value: 'email' },
        { text: 'Numérico', value: 'number' },
      ],
      leadFields: [
        { description: null, identifier: null },
      ],
      options: [{}],
      showOptions: false,
      showAdvanced: false,
      integrationLoading: false,
      customField: {
        showModal: false,
        previousValue: '',
      },
    };
  },

  computed: {
    requiredCheck () {
      return (this.modal.rules || '').indexOf('required') !== -1;
    },

    disabled () {
      return this.status.saving === true;
    },

    showMask () {
      return ['date', 'time'].includes(this.modal.type) === false;
    },
  },

  watch: {
    'modal.type': function (type) {
      if (type === 'select' || type === 'radio' || type === 'checkbox') {
        this.showOptions = true;
      } else {
        this.showOptions = false;
      }
    },
  },

  methods: {
    getForm () {
      this.$http.get(`/form/${this.form.id}/question`)
        .then((response) => {
          this.questions = _.sortBy(response.data, 'order');
          this.loading = false;
        });
    },

    getCustomFields () {
      this.$http.get('/settings/field')
        .then(({ data }) => data.forEach((field) => {
          if (['first_name', 'last_name'].includes(field.identifier)) {
            return;
          }

          this.leadFields.push({
            description: field.description,
            identifier: field.identifier,
          });
        }));
    },

    getTypeName (question) {
      const name = _.find(question.type, (type) => question.type == type.value);

      return name || question.type;
    },

    newQuestion () {
      this.modalData({});
      this.options = [];
      this.modalElement.toggle();
    },

    modalData (data) {
      this.modal.id = data.id;
      this.modal.title = data.title,
      this.modal.question = data.question,
      this.modal.name = data.name,
      this.modal.type = data.type || 'text',
      this.modal.cols = data.cols,
      this.modal.rules = (data.rules === undefined) ? 'required' : data.rules;
      this.modal.mask = data.mask;
      this.modal.step = data.step;
      this.modal.placeholder = data.placeholder;
    },

    editQuestion (id, index) {
      this.options = [];
      this.modal.id = id;
      this.status.questionInEditionIndex = index;
      this.modalData(this.questions[index]);
      this.options = this.questions[index].options || [];

      this.status.requiredCheck = (this.modal.rules || '').indexOf('required') !== -1;
      this.modalElement.toggle();
    },

    createQuestion () {
      this.status.saving = true;
      this.modal.options = this.options;

      this.$http.post(`/form/${this.form.id}/question`, this.modal)
        .then((response) => {
          Alert.info(this.__('Campo cadastrado'));

          this.modalElement.hide();

          this.questions.push(response.data);
        })
        .catch((response) => {
          if (response.status === 422) {
            return Alert.error(this.__('Preencha o título do campo.'));
          }

          Alert.error(this.__('Erro ao cadastrar campo'));
        })
        .finally((response) => {
          this.status.saving = false;
        });

      return false;
    },

    checkRequired () {
      if (this.modal.rules.indexOf('required') === -1) {
        return this.modal.rules = this.modal.rules ? (`${this.modal.rules}|required`) : 'required';
      }

      this.modal.rules = this.modal.rules.replace('required|', '').replace('required', '');
    },

    updateQuestion () {
      const questionId = this.modal.id;

      this.modal.options = this.options;

      this.$http.put(`/form/${this.form.id}/question/${questionId}`, this.modal)
        .then((response) => {
          Alert.info(this.__('Campo atualizado'));

          this.modalElement.hide();
          this.status.saving = false;

          const { data } = response;
          const i = this.status.questionInEditionIndex;

          this.questions[i] = this.questions[i] || {};
          this.questions[i].id = data.id;
          this.questions[i].title = data.title;
          this.questions[i].question = data.question;
          this.questions[i].name = data.name;
          this.questions[i].type = data.type;
          this.questions[i].cols = data.cols;
          this.questions[i].rules = data.rules;
          this.questions[i].mask = data.mask;
          this.questions[i].step = data.step;
          this.questions[i].placeholder = data.placeholder;

          this.modalData({});
          this.options = [];
        })
        .catch((response) => {
          if (response.status === 422) {
            return Alert.error(this.__('Preencha o título do campo.'));
          }

          Alert.error(this.__('Erro ao cadastrar campo'));
        })
        .finally((response) => {
          this.status.saving = false;
        });
    },

    submitQuestion () {
      this.status.saving = true;
      if (this.modal.id) {
        this.updateQuestion();
      } else {
        this.createQuestion();
      }
    },

    addOption () {
      this.options.push({});
    },

    removeOption (option) {
      if (! option.id) {
        return this.options.splice(this.options.indexOf(option), 1);
      }

      this.$http.delete(`/form/${this.form.id}/question/${this.modal.id}/option/${option.id}`)
        .then((response) => {
          this.options.splice(this.options.indexOf(option), 1);
        })
        .catch((response) => {
          Alert.error(this.__('Erro ao remover opção'));
        });
    },

    async removeQuestion (id, index) {
      if (! await Confirm(this.__('Deseja excluir?'))) {
        return;
      }

      this.$http.delete(`/form/${this.form.id}/question/${id}`)
        .then((response) => {
          for (const i in this.questions) {
            const question = this.questions[i];

            if (question.id == id) {
              this.questions.splice(i, 1);
            }
          }
        })
        .catch((response) => {
          Alert.error(response.message);
        });
    },

    updateQuestionsOrder () {
      const order = this.questions.map((question) => question.id);

      this.$http.put(`/form/${this.form.id}/question-order`, { orders: order })
        .then((response) => {
          Alert.success(this.__('Ordem alterada!'));
        })
        .catch((response) => {
          Alert.error(this.__('Erro ao alterar ordem, tente novamente mais tarde.'));
        });
    },

    selectIntegration () {
      Selection.selectText(this.$refs.integration);
    },

    integrationOpen () {
      // this.integrationLoading = true;

      // this.$http.get('/form/integration/javascript?form=' + this.form.hashid)
      //   .then(response => {
      //     this.integrationLoading = false;

      //     if (response.data && this.$refs.integration) {
      //       this.$refs.integration.textContent = response.data;
      //     }
      //   });
    },

    selectField (value) {
      this.modal.name = value;
    },
  },
};
</script>
